import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import FlowSection from '../../components/root/shared/FlowSection.tsx';
import {
  MANAGER_APPROVAL_LETTER_MANUAL_SIGN_LOADING_TEXT,
  MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT,
} from './constants.ts';

type TManualSignGeneratedDocumentSectionProps = {
  isDocumentLoading: boolean;
  pdfUrl: string;
  onOpenPdf: () => void;
};

const ManualSignGeneratedDocumentSection: React.FC<
  TManualSignGeneratedDocumentSectionProps
> = ({ isDocumentLoading, pdfUrl, onOpenPdf }) => (
  <FlowSection
    step={MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT.sectionStep}
    title={MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT.sectionTitle}
    description={MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT.sectionDescription}
  >
    <Box sx={guaranteesClientPageStyles.generatedDocumentPreview}>
      {isDocumentLoading ? (
        <Box sx={guaranteesClientPageStyles.flowLoadingState}>
          <CircularProgress size={24} />
          {MANAGER_APPROVAL_LETTER_MANUAL_SIGN_LOADING_TEXT}
        </Box>
      ) : (
        <Box
          component="iframe"
          src={pdfUrl || undefined}
          title={MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT.previewTitle}
          sx={guaranteesClientPageStyles.generatedDocumentIframe}
        />
      )}

      <Box sx={guaranteesClientPageStyles.generatedDocumentActions}>
        <Button
          variant="outlined"
          color="primary"
          type="button"
          sx={guaranteesClientPageStyles.generatedDocumentOpenButton}
          disabled={!pdfUrl}
          onClick={onOpenPdf}
        >
          {MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT.openButton}
        </Button>
      </Box>
    </Box>
  </FlowSection>
);

export default ManualSignGeneratedDocumentSection;
